export default {
    getters: {
        optionsProspectStatut: () => {
            return [
                { label : 'En cours',    value: 1 },
                { label : 'Importé',     value: 2 },
                { label : 'LDM envoyée', value: 3 },
                { label : 'LDM reçue',   value: 4 },
            ]
        },

        optionsProspectProvenance: () => {
            return [
                { label : 'Publicité',  value: 'publicite' },
                { label : 'Interne',    value: 'interne'   },
                { label : 'Partenaire', value: 'partenaire'},
                { label : 'Internet',   value: 'internet'  },
                { label : 'Client',     value: 'client'    },
                { label : 'Evénement',  value: 'evenement' },
                { label : 'Valority',   value: 'valority'  },
                { label : 'Simulateur', value: 'simulateur'},
            ]
        },

        optionsProspectPeriodicite: () => {
            return [
                { label : 'Unique',             value: '0' },
                { label : 'Mensuelle',          value: '1' },
                { label : 'Bimestrielle',       value: '2' },
                { label : 'Trimestrielle',      value: '3' },
                { label : 'Quadrimestrielle',   value: '4' },
                { label : 'Semestrielle',       value: '6' },
                { label : 'Annuelle',           value: '12' },
            ]
        },

        optionsProspectSansSuiteRaison: () => {
            return [
                { label:'Proximité', value:'proximite'},
                { label:'Tarifs', value:'tarifs'},
                { label:'Projet annulé', value:'projet_annule'},
                { label:'Sans motif', value:'sans_motif'},
                { label:'Autre', value:'autre'}
            ]
        },
    }
}
